import React from 'react';
import { motion } from 'framer-motion';
import { ThumbsUp } from 'lucide-react';
interface CommentCardProps {
  name: string;
  initial: string;
  timestamp: string;
  text: string;
  likes: number;
  index?: number;
}
export function CommentCard({
  name,
  initial,
  timestamp,
  text,
  likes,
  index = 0
}: CommentCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    delay: index * 0.05
  }} className="border-b border-gray-200 pb-6 last:border-b-0" data-id="element-30">
      <div className="flex items-start gap-3" data-id="element-31">
        <div className="w-10 h-10 rounded-full bg-gradient-to-br from-gray-400 to-gray-600 flex items-center justify-center text-white text-sm font-semibold flex-shrink-0" data-id="element-32">
          {initial}
        </div>
        <div className="flex-1 min-w-0" data-id="element-33">
          <div className="flex items-baseline gap-2 mb-1" data-id="element-34">
            <p className="font-semibold text-sm text-gray-900" data-id="element-35">{name}</p>
            <span className="text-xs text-gray-500" data-id="element-36">{timestamp}</span>
          </div>
          <p className="text-sm text-gray-700 leading-relaxed mb-3" data-id="element-37">{text}</p>
          <button className="flex items-center gap-1.5 text-xs text-gray-500 hover:text-blue-600 transition-colors" data-id="element-38">
            <ThumbsUp size={14} data-id="element-39" />
            <span data-id="element-40">{likes}</span>
          </button>
        </div>
      </div>
    </motion.div>;
}